export const validation = {
  iana_name: (value) => {
    if (!value?.trim()) return "IANA name is required";
    return "";
  },
  display_name: (value) => {
    if (!value?.trim()) return "Display name is required";
    return "";
  },
  utc_offset: (value) => {
    if (!value?.trim()) return "UTC offset is required";
    return "";
  },
};
